declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

// HARDCODED — the only Pixel ID for this project
const PIXEL_ID = '1493847205417473'
let initialized = false

export function initMetaPixel() {
  if (typeof window === 'undefined') return

  // Nuke any stale pixel completely
  if (window.fbq) {
    delete window.fbq
    delete window._fbq
  }

  // Remove ALL existing fbevents scripts
  document
    .querySelectorAll('script[src*="fbevents"]')
    .forEach((s) => s.remove())

  initialized = false

  // Fresh Facebook Pixel bootstrap
  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const first = document.getElementsByTagName('script')[0]
  first?.parentNode?.insertBefore(script, first)

  // Initialize with the CORRECT pixel ID
  window.fbq('init', '1493847205417473')
  initialized = true
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
